
import { defineComponent, computed } from 'vue';
import Vue3Datepicker from 'vue3-datepicker';
import { de, enGB, fr, it } from 'date-fns/locale';
import { useI18n } from 'vue-i18n';

const getDatePickerLanguage = (lang: string) => {
    switch (lang) {
        case 'en':
            return enGB;
        case 'fr':
            return fr;
        case 'it':
            return it;
        case 'de':
        default:
            return de;
    }
};

export default defineComponent({
    name: 'Datepicker',
    components: {
        Vue3Datepicker,
    },
    props: {
        modelValue: Vue3Datepicker.props.modelValue,
        lowerLimit: Vue3Datepicker.props.lowerLimit,
        upperLimit: Vue3Datepicker.props.upperLimit,
        disabledDatapicker: Boolean,
        disabledDates: Vue3Datepicker.props.disabledDates,
        type: Vue3Datepicker.props.type,
    },
    emits: ['update'],
    setup(props) {
        const i18n = useI18n({ useScope: 'global' });

        const disabledDatesArr = computed(() => props.disabledDates);
        const disabled = computed(() => props.disabledDatapicker);

        return {
            datepickerLanguage: getDatePickerLanguage(i18n.locale.value),
            disabledDatesArr,
            disabled,
        };
    },
});
